import { Injectable, signal } from '@angular/core';
import { waitForMillis } from '@shared/delay.utils';

type TNotification = {
  title?: string;
  message?: string;
};

@Injectable({
  providedIn: 'root',
})
export class LpNotificationsService {
  notification = signal<TNotification | undefined>(undefined);

  private queue: TNotification[] = [];
  private done = signal(true);

  constructor() {
    const tick = async () => {
      if (this.done()) {
        if (this.notification() !== undefined) {
          this.notification.set(undefined);
          await waitForMillis(100);
        }

        const next = this.queue.shift();
        if (next) {
          this.done.set(false);
          this.notification.set(next);
        }
      }

      requestAnimationFrame(tick);
    };
    tick();
  }

  private async waitUntilEmpty(): Promise<void> {
    while (this.queue.length > 0) {
      await waitForMillis(50);
    }
    await waitForMillis(100); // wait for the notification to transition out
  }

  public async show(title: string | undefined, message: string | undefined): Promise<void> {
    this.queue.push({
      title,
      message,
    });
    await this.waitUntilEmpty();
  }

  public next() {
    this.done.set(true);
  }
}
